import React from "react";

const DataSamplingWidget: React.FC = () => {
  return (
    <div className="widget">
      <h2 className="text-lg font-bold mb-2">Data Sampling</h2>
      <img
        src="/images/DataSamplingWidget.png"
        alt="Data Sampling Chart"
        className="w-full h-auto"
      />
    </div>
  );
};

export default DataSamplingWidget;
